import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { DTypeForm } from '@grupo-constant/next-dtype/form';
import { DtypeComponentListComponent } from '../dtype-component-list/dtype-component-list.component';

@Component({
    selector: 'dtype-details',
    templateUrl: './dtype-details.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DtypeComponentListComponent]
})
export class DtypeDetailsComponent {

    @Input({ required: true }) dtypeForm: DTypeForm;
    @Input() isUpdate = false;

}
